import React, { useState, useEffect } from 'react';
import './Table.scss';

const Table = ({ 
    columns = [],
    data = [],
    onRowClick
}) => {
    const [openMenuId, setOpenMenuId] = useState(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openMenuId && !event.target.closest('.octopus-table-menu-wrapper')) {
                setOpenMenuId(null);
            }
        };

        if (openMenuId) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [openMenuId]);

    return (
        <div className="octopus-table-wrapper">
            <table className="octopus-table">
                <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th 
                                key={column.key || index}
                                className={`octopus-table-col-${column.key}`}
                                style={column.headerStyle || {}}
                            >
                                {column.label}
                                {column.sortable && (
                                    <i className="fa-solid fa-sort"></i>
                                )}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => {
                        const rowId = row.id || row.project_id || row.task_id || row.category_id || rowIndex;
                        return (
                            <tr 
                                key={rowId}
                                className="octopus-table-row"
                                onClick={() => onRowClick && onRowClick(rowId, row)}
                            >
                                {columns.map((column, colIndex) => (
                                    <td 
                                        key={column.key || colIndex}
                                        className={`octopus-table-col-${column.key}`}
                                        style={column.cellStyle || {}}
                                    >
                                        {column.render ? column.render(row, rowIndex, { openMenuId, setOpenMenuId }) : row[column.key]}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
